/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CompanyFilter,
  CompanyGet,
  CreateCompanyPayload,
  DeleteCompanyPayload,
  GetCompanyListParams,
  TableModel1CompanyGet,
  UpdateCompanyPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Company<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Companies
   * @name CompanyDetail
   * @summary Получить организацию по идентификатору
   * @request GET:/company/{id}
   * @secure
   * @response `200` `CompanyGet` Организация
   */
  companyDetail = (id: string, params: RequestParams = {}) =>
    this.request<CompanyGet, any>({
      path: `/company/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name GetCompanyList
   * @summary Возвращает список организации.
   * @request POST:/company/list
   * @secure
   * @response `200` `TableModel1CompanyGet` Список организаций
   */
  getCompanyList = (query: GetCompanyListParams, data: CompanyFilter, params: RequestParams = {}) =>
    this.request<TableModel1CompanyGet, any>({
      path: `/company/list`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name CreateCompany
   * @summary Создание организации
   * @request POST:/company/create
   * @secure
   * @response `200` `void` Success
   */
  createCompany = (data: CreateCompanyPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/company/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name UpdateCompany
   * @summary Обновление организации
   * @request POST:/company/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateCompany = (id: string, data: UpdateCompanyPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/company/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Companies
   * @name DeleteCompany
   * @summary Удаление организации
   * @request POST:/company/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteCompany = (data: DeleteCompanyPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/company/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
